import { useState } from "react";
import { Globe, Lock } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "./ui/switch";
import api from "../lib/api";

// S5: owner opt-in to appear on the public home-page wall (off by default).
export const PublicWallToggle = ({ creation, onUpdate }) => {
  const [on, setOn] = useState(!!creation.public_wall);
  const [busy, setBusy] = useState(false);

  const toggle = async (next) => {
    setOn(next);
    setBusy(true);
    try {
      const { data } = await api.post(`/creations/${creation.id}/visibility`, { public_wall: next });
      onUpdate?.(data);
      toast.success(next ? "Your duck can now appear on the public wall." : "Removed from the public wall.");
    } catch {
      setOn(!next);
      toast.error("Couldn't update visibility — please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="public-wall-toggle" className="flex items-center gap-3 rounded-2xl border border-border bg-card/60 px-4 py-3">
      {on ? <Globe className="h-4 w-4 text-accent shrink-0" /> : <Lock className="h-4 w-4 text-muted-foreground shrink-0" />}
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold">Show on the public wall</p>
        <p className="text-xs text-muted-foreground">Off by default. When on, this duck may appear on the Duckify home page.</p>
      </div>
      <Switch data-testid="public-wall-switch" checked={on} disabled={busy} onCheckedChange={toggle} />
    </div>
  );
};
